<template>
  <div
    id="js-product-details-delivery-dates-simple-container"
    class="product-details-delivery-date-simple-transfers"
    :class="{ 'product-details-delivery-date-simple-transfers--compact': compact }"
    :data-product-id="productSlug"
    data-selected-color="Transfer"
    :data-is-dtf="isDtfSheet"
    :data-enabled-shipping-enhancement-services="false"
    data-assignable="true"
  >
    <div
      class="product-details-delivery-date-simple-transfers__loading js-product-details-delivery-dates-simple-spinner"
    >
      <span class="product-details-delivery-date-simple-transfers__loading-text">
        Getting Earliest Delivery Date
      </span>
      <slot name="dates"></slot>
    </div>

    <div
      class="product-details-delivery-date-simple-transfers__wrapper js-product-details-delivery-dates-simple-wrapper hidden"
    >
      <div
        class="product-details-delivery-date-simple-transfers__delivery js-product-details-delivery-dates-simple-shipment"
      >
        <UseSvg
          v-if="compact"
          icon="lightning-1"
          class="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--lightning"
        />
        <UseSvg
          v-else
          icon="box-jiffy-check"
          class="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--box"
        />
        <span class="product-details-delivery-date-simple-transfers__delivery-date-label">
          Get it
          <span
            class="js-product-details-delivery-dates-simple-direct-value product-details-delivery-date-simple-transfers__delivery-date-value"
          ></span>
        </span>
        <UseSvg
          v-if="compact"
          icon="lightning-1"
          class="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--lightning-end"
        />
      </div>

      <div
        class="product-details-delivery-date-simple-transfers__cutoff js-product-details-delivery-dates-simple-cutoff-wrapper"
      >
        Order by
        <b
          class="js-product-details-delivery-dates-cutoff product-details-delivery-date-simple-transfers__cutoff-date"
        >
          ...
        </b>
        <span class="js-expedite-shipping-note"></span>
      </div>
      <button
        v-if="!hideAddressLine"
        class="product-details-delivery-date-simple-transfers__change-location-button js-deliver-to-toggle-modal"
        type="button"
        data-mixpanel-context="product_detail"
      >
        <UseSvg
          icon="marker-pin"
          class="product-details-delivery-date-simple-transfers__change-location-button-icon"
        />

        <span
          class="product-details-delivery-date-simple-transfers__deliver-to-message js-deliver-to-pdp-addr"
        >
          Select Your Address
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "common/vue/components/UseSvg.vue";
import { useDtfStore } from "./store";

export default {
  name: "DeliveryDate",
  components: {
    UseSvg
  },
  props: {
    hideAddressLine: {
      type: Boolean,
      default: false
    },
    isSameDay: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useDtfStore, ["isDtfSheet", "productSlug", "experiments"])
  }
};
</script>
